import { StatusHistoryChainModel } from '../../../../common/models/status-history-chain.model';
import { TransportMode } from '../../../../common/constants/transport-mode';

export class ShipmentWaybillStatusHistoryMainInfo {
  reference: string;
  carriers: string[];
  carriageConditionCodes: string[];
  transportServicePriorityCode: string;
  transportMode: TransportMode;
}

export class ShipmentWaybillStatusHistoryStatuses {
  statuses: StatusHistoryChainModel[];
}

export class ShipmentWaybillStatusHistory {
  mainIfo: ShipmentWaybillStatusHistoryMainInfo;
  statusHistoryView: ShipmentWaybillStatusHistoryStatuses;
}
